// extracted by mini-css-extract-plugin
export default {"container":"TheContainer_container_WZ54P"};